import $ from 'jquery';

document.addEventListener('click', (event) => {
  if ($(event.target).hasClass('js-seo-menu-link')) {
    sessionStorage.setItem('menuParentCategory', $(event.target).closest('.js-seo-link-parent').attr('data-seo-parent-category'));
  } else {
    sessionStorage.removeItem('menuParentCategory');
  }
});


// WEBPACK FOOTER //
// ./src/js/get-menu-category.js